import { PrintArea, View } from '@/types';
import { assertDefined } from '@/utils/assertDefined';

export const getViewMapByPrintArea = (view: View, printArea: PrintArea) =>
  assertDefined(view.viewMaps.find((viewMap) => viewMap.printArea.id === printArea.id));
